require('./brokerRightsCashExchangeSuccess.scss');

// @Vendor
const React = require('react');
const PropTypes = require('prop-types');

// @Helpers
const { formatAccountTextWithSpaces } = require('utilities/ibanHelper');
const { formatAmountObject, getPlainAmountObject } = require('utilities/currencyHelper');

// @Components
const WizardSuccess = require('components/commons/wizardSuccess/wizardSuccess');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { formatText, FormattedText, getLanguage } = require('core/i18n').i18n;

// @Commons
const { OneLineSymbolAmount } = require('commonsComponents/oneLineSymbolAmount');

// @Constants
const {
    BROKER_CORPORATE_OPERATIONS_URL,
    CHARGE_ACCOUNT_PREFIX,
    FIRST_STEP,
    MYPROFILE_BROKER_URL
} = require('constants/index');

class BrokerRightsCashExchangeSucess extends React.Component {
    buildSummaryLeftContainer() {
        const { immBrokerRightsCashExchange } = this.props;
        const immSelectedOperation = immBrokerRightsCashExchange.get('selectedOperation');
        const immSelectedContract = immBrokerRightsCashExchange.get('selectedContract');
        const valueDescription = immSelectedOperation.get('descriptionValue');
        const contractDescription = immSelectedContract.get('walletAccountType');
        const controlDigit = immSelectedContract.getIn(['cuenta', 'digitodecontrol']);
        const contractNumber = immSelectedContract.getIn(['cuenta', 'fullNumber']);
        const fullContractNumber = `${CHARGE_ACCOUNT_PREFIX}${controlDigit}${contractNumber}`;
        const formattedContractNumber = fullContractNumber ? formatAccountTextWithSpaces(fullContractNumber, [4, 4, 2]) : '';
        const holder = immSelectedContract.get('owner');
        const fullAccountNumber = immSelectedContract.getIn(['associatedAccount', 'number']);
        const formattedAccountNumber = fullAccountNumber ? formatAccountTextWithSpaces(fullAccountNumber, [4, 4, 2]) : '';
        const accountBalance = immSelectedContract.getIn(['associatedAccount', 'balance']);
        const plainAmountObject = getPlainAmountObject(accountBalance);
        return (
            <div className="col-lg-4 broker-rights-cash-exchange-success__titles-container-left">
                <div>
                    <OKInformativeList>
                        <OKInformativeListItem
                            title={formatText('brokerRightsCashExchange-brokerRightsCashExchange_successValueLabel')}
                            bodyText={valueDescription}
                            columns={1}
                            isUppercaseTitle={true}
                        />
                        <OKInformativeListItem
                            title={formatText('brokerRightsCashExchange-brokerRightsCashExchange_successContractLabel')}
                            bodyText={contractDescription}
                            columns={1}
                            isUppercaseTitle={true}
                        >
                            <div className="broker-rights-cash-exchange-success__stock-container-info">
                                <div className="broker-rights-cash-exchange-success__stock-container-info--item">
                                    <FormattedText
                                        value="brokerRightsCashExchange-brokerRightsCashExchange_successContractNumber"
                                        injectedStrings={[formattedContractNumber]}
                                    />
                                    <br />
                                    <FormattedText
                                        value="brokerRightsCashExchange-brokerRightsCashExchange_successHolderLabel"
                                        injectedStrings={[holder]}
                                    />
                                </div>
                                <div className="broker-rights-cash-exchange-success__stock-container-info--item">
                                    <FormattedText
                                        value="brokerRightsCashExchange-brokerRightsCashExchange_successAccountLabel"
                                        injectedStrings={[formattedAccountNumber]}
                                    />
                                    <br />
                                    <FormattedText value="brokerRightsCashExchange-brokerRightsCashExchange_balancePrefix" />
                                    <OneLineSymbolAmount
                                        amountObject={plainAmountObject}
                                        language={getLanguage()}
                                        amountObjectFormatted={formatAmountObject(plainAmountObject, true)}
                                    />
                                    <FormattedText value="brokerRightsCashExchange-brokerRightsCashExchange_balanceSuffix" />
                                </div>
                            </div>
                        </OKInformativeListItem>
                    </OKInformativeList>
                </div>
            </div>
        );
    }

    buildSummaryRightContainer() {
        const { immBrokerRightsCashExchange } = this.props;
        const availableRights = immBrokerRightsCashExchange.getIn(['steps', FIRST_STEP, 'rightsQuantity']);
        return (
            <div className="col-lg-8 broker-rights-cash-exchange-success__titles-container-right">
                <div>
                    <OKInformativeList>
                        <OKInformativeListItem
                            title={formatText('brokerRightsCashExchange-brokerRightsCashExchange_step1AmountText')}
                            bodyText={availableRights}
                            columns={1}
                            isUppercaseTitle={true}
                        />
                    </OKInformativeList>
                </div>
            </div>
        );
    }

    render() {
        const { immBrokerRightsCashExchange } = this.props;
        const orderNumber = immBrokerRightsCashExchange.getIn(['confirmationData', 'orderNumber'])
        const title = formatText('brokerRightsCashExchange-brokerRightsCashExchange_successTitle');
        const subtitle = orderNumber ? __CONTACT_CENTER__ && `${formatText('brokerRightsCashExchange-brokerRightsCashExchange_successSubtitle')}${orderNumber}` : null;
        const mainButton = {
            label: formatText('brokerRightsCashExchange-brokerRightsCashExchange_successSecondaryButton'),
            url: MYPROFILE_BROKER_URL,
            modifier: 'secondary'
        }
        const secondaryButton = {
            label: formatText('brokerRightsCashExchange-brokerRightsCashExchange_successMainButton'),
            url: BROKER_CORPORATE_OPERATIONS_URL,
        };

        return (
            <div className="broker-rights-cash-exchange-success">
                <WizardSuccess
                    successMessage={title}
                    successMessageChildren={subtitle}
                    mainButton={mainButton}
                    secondaryButton={secondaryButton} >
                    <div className="broker-rights-buy-success__info-section row">
                        {this.buildSummaryLeftContainer()}
                        {this.buildSummaryRightContainer()}
                    </div>
                </WizardSuccess>
            </div>
        );
    }
}

BrokerRightsCashExchangeSucess.propTypes = {
    immBrokerRightsCashExchange: PropTypes.object.isRequired
}

module.exports = BrokerRightsCashExchangeSucess;
